export default __webpack_public_path__ + "static/media/managerActive.a7aeb249.svg";